import type { SessionPolicy } from '@easyflow/shared';
import type { SessionDurations, SessionEngineTiming } from './types';

/**
 * UNICA dichiarazione dei default di policy (15 min di inattività, avviso
 * negli ultimi 2 min, rinnovo token sotto 5 min residui). È solo un fallback:
 * i frontend passano le durate ricevute dal server via `sessionPolicyToConfig`.
 */
export const DEFAULT_SESSION_POLICY: SessionDurations = Object.freeze({
  idleTimeoutMs: 15 * 60_000,
  warnBeforeMs: 2 * 60_000,
  refreshThresholdMs: 5 * 60_000,
});

/** Default dei parametri interni del motore (tick 10 s, throttle 5 s). */
export const SESSION_ENGINE_TIMING: SessionEngineTiming = Object.freeze({
  tickIntervalMs: 10_000,
  activityThrottleMs: 5_000,
});

/** Converte il DTO server (secondi) nelle durate del motore (millisecondi). */
export function sessionPolicyToConfig(policy: SessionPolicy): SessionDurations {
  return {
    idleTimeoutMs: policy.idleTimeoutSec * 1000,
    warnBeforeMs: policy.warnBeforeSec * 1000,
    refreshThresholdMs:
      policy.refreshThresholdSec !== undefined
        ? policy.refreshThresholdSec * 1000
        : DEFAULT_SESSION_POLICY.refreshThresholdMs,
  };
}
